import './App.css';
import AssessmentsTable from './AssessmentsTable';
import SearchesTable from './SearchesTable';

function App() {
  return (
    <div className="App">
      <header className="d-flex justify-content-center" style={{paddingTop: 16}}>
        <h4 style={{marginBottom: 0}}>Search Triage Development - Admin</h4>        
      </header>      
      <p>Logged in as {window.global_IdentityName}</p>
      <ul className="nav nav-underline justify-content-center" role="tablist">
        <li className="nav-item">
          <button className="nav-link active" id="assessments-tab" data-bs-toggle="tab" data-bs-target="#assessments-tab-pane" type="button" role="tab" aria-controls="assessments-tab-pane">Assessments (loading)</button>
        </li>
        <li className="nav-item">
          <button className="nav-link disabled" id="searches-tab" data-bs-toggle="tab" data-bs-target="#searches-tab-pane" type="button" role="tab" aria-controls="searches-tab-pane">Registered Searches (loading)</button>
        </li>
      </ul>
      <br/>
      <hr style={{margin: "auto"}} width="75%"/>
      <div className="tab-content">
        <div id="assessments-tab-pane" className="container tab-pane active" role="tabpanel">
          <br/>
          <AssessmentsTable onLoaded={() => {
            const element = document.getElementById('assessments-tab');
            element.classList.remove('disabled');
            element.innerText = 'Assessments';
            }}/>
        </div>
        <div id="searches-tab-pane" className="container tab-pane fade" role="tabpanel">
          <br/>
          <SearchesTable onLoaded={() => {
            const element = document.getElementById('searches-tab');
            element.classList.remove('disabled');
            element.innerText = 'Registered Searches';
            }}/>
        </div>        
      </div>      
    </div>    
  );
}

export default App;
